import React from 'react'
const WidgetContext = React.createContext<any>({})
export default WidgetContext
